module.exports = __webpack_public_path__ + "static/img/station01.cff7df95.png";